<template>
  <v-card>
     <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        class='font-weight-light'
        v-model="search"
        append-icon="mdi-magnify"
        label="Search code year"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :loading='loading'
      :headers='headers'
      :items='codeYearList'
      :search='search'
      loading-text="Loading... Please wait"
      class='elevation-1'
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
          <v-spacer></v-spacer>
         <v-dialog default v-model='dialog' max-width='500px' scrollable>
            <template v-slot:activator='{ on }'>
              <v-btn outlined dark class='mb-2 fontcolor' v-on='on'  @click="hideEditedFields">
                <v-icon dark>mdi-plus</v-icon>
                {{ ADD_NEW_CODE_YEAR }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class='headline fontcolor'>{{ formTitle }}</span>
              </v-card-title>
              <v-card class="pl-7 pr-6 pt-5 pb-5" >
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model='editedItem.year'
                        hint='Please enter a Code Year'
                        label='Code Year*'
                        :rules="yearValidationRules"
                        :maxlength=4
                        :min=4
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="editedFields" >
                      <v-select
                        v-model='editedItem.status'
                        :items="statusItems"
                        label="Status*"
                        :rules="statusValidationRules"
                        item-text="statusText"
                        item-value="statusVal"
                      ></v-select>
                    </v-col>
                    <v-col v-else >
                      <v-select
                        v-model='defaultStatus'
                        :items="defaultStatusItems"
                        label="Status*"
                        :rules="statusValidationRules"
                        id="statusFieldId"
                      ></v-select>
                    </v-col>
                  </v-row>
                   <!-- Below fields will view only on edit county form.
                      All below fields will be in disable mode.
                   -->
                  <v-row v-if="editedFields">
                  <v-col>
                      <v-text-field disabled v-model='editedItem.createdBy'
                      label='Created By'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.createdDate'
                      label='Created On'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields && (editedItem.createdDate !== editedItem.modifiedDate)">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.modifiedBy'
                      label='Modified By'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields && (editedItem.createdDate !== editedItem.modifiedDate)">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.modifiedDate'
                      label='Modified On'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <small color="primary">*indicates required fields</small>
                    <v-spacer></v-spacer>
                    <v-btn outlined dark color='red' @click='closeDialogFrm'>
                      <v-icon dark>mdi-close</v-icon>Cancel
                    </v-btn>
                    <v-btn :loading='btnLoader' outlined class='fontcolor' :disabled="!valid" @click='save'>
                      <v-icon dark>mdi-check</v-icon>Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action='{ item }'>
        <v-icon text small class='mr-2' @click='editItem(item)'>mdi-border-color</v-icon>
        <v-icon v-if="item.status === 1" text small class='mr-2' @click='deleteCodeYear(item)'>delete</v-icon>
      </template>
    </v-data-table>
    <template>
      <ConfirmationBox  :dialog="deleteDialog" title='Delete Code Year' :discription="dialogDiscription" :cancel="cancel" :confirm="confirmDelete" :btnLoaderConfirm="btnLoaderConfirm" />
      <AlertBox :alertDialog="alertDialog"  :discription="alertDiscription" :cancel="closeAlertBox" />
    </template>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
export default {
  data: () => ({
    search: '',
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_CODE_YEAR,
    ADD_NEW_CODE_YEAR: CONSTANTS.ADD_NEW_CODE_YEAR,
    loading: true,
    dialog: false,
    valid: true,
    edited: false,
    btnLoader: false,
    // defalutStatus: { statusText: 'Inactive', statusVal: 1 },
    defalutStatus: 1,
    yearValidationRules: [
      v => !!v || 'Code Year is required.',
      v => /^\d{4}$/.test(v) || 'Invalid input. Only 4-digit numeric value (0-9) is allowed!'
    ],
    statusValidationRules: [
      v => !!v || 'Status is required.'
    ],
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    deleteIndex: -1,
    deleteDialog: false,
    alertDialog: false,
    dialogDiscription: '',
    alertDiscription: '',
    btnLoaderConfirm: false,
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'Year',
        value: 'year',
        sortable: true,
        class: 'title'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: false,
        class: 'title'
      },
      { text: 'Actions', value: 'action', sortable: false, class: 'title' }
    ],
    editedIndex: -1,
    editedItem: {
      year: '',
      status: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    }
  }),
  components: {
    ConfirmationBox: () => import('./../../locations/modelbox/ConfirmationBox.vue'),
    AlertBox: () => import('./../../locations/modelbox/AlertBox.vue')
  },
  mounted () {
    this.initialize()
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add New Code Year' : 'Edit Code Year'
    },
    codeYearList () {
      return this.$store.getters['CodeYearModule/fetchCodeYearList']
    },
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    editedFields () {
      return this.edited
    }
  },
  methods: {
    initialize () {
      new Promise((resolve, reject) => {
        // let status = '' // use this parameter for record statue published/inactive
        this.$store.dispatch('CodeYearModule/getCodeYearList', { resolve, reject })
      }).then((responseData) => {
        this.loading = false
      }).catch(({ response }) => {
        this.loading = false
      })
    },
    hideEditedFields () {
      this.edited = false
    },
    editItem (selectedRecord) {
      this.editedIndex = this.codeYearList.indexOf(selectedRecord)
      this.editedItem = Object.assign({}, selectedRecord)
      this.dialog = true
      this.edited = true
    },
    closeDialogFrm () {
      this.editedItem = Object.assign({}, {})
      this.editedIndex = -1
      this.editedItem.name = ''
      this.editedItem.status = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.defaultStatus = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.$refs.form.resetValidation()
      this.dialog = false
    },
    save () {
      if (this.editedIndex > -1 && this.$refs.form.validate()) {
        this.btnLoader = true
        Object.assign(this.editedItem)
        let editYearData = this.editedItem
        const editedData = {
          year: editYearData.year,
          status: editYearData.status,
          userId: this.userId,
          id: Number(editYearData.id)
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('CodeYearModule/editCodeYearItem', { resolve, reject, editedData })
        }).then((responseData) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
          this.closeDialogFrm()
        }).catch((response) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
      } else {
        if (this.$refs.form.validate()) {
          let statusField = 1
          if (this.defaultStatus === 'Inactive') {
            statusField = this.statusValues.Inactive
          } else if (this.defaultStatus === 'Published') {
            statusField = this.statusValues.Published
          }
          this.btnLoader = true
          const formData = {
            year: this.editedItem.year,
            status: statusField,
            userId: this.userId
          }
          new Promise((resolve, reject) => {
            this.$store.dispatch('CodeYearModule/addCodeYearItem', { resolve, reject, formData })
          }).then((responseData) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.closeDialogFrm()
          }).catch((response) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = response.responseMessage
            this.$globalStates.notification.init_notifications = true
          })
        }
      }
    },
    // DELETE Code Year START HERE
    cancel () {
      this.deleteDialog = false
    },
    closeAlertBox () {
      this.alertDialog = false
    },
    deleteCodeYear (item) {
      const formData = {
        userId: this.userId,
        id: item.id,
        isValidation: true
      }
      this.deleteIndex = item.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('CodeYearModule/validateCodeYearItem', {
          resolve,
          reject,
          formData
        })
      })
        .then(responseData => {
          this.deleteDialog = true
          this.dialogDiscription = `'` + item.year + `' Code Year`
        })
        .catch(response => {
          this.alertDialog = true
          let message = `A few reference(s) exist in other Entity(s), please remove all references and try again to delete '` + item.year + `' Code Year.`
          this.alertDiscription = message
        })
    },
    confirmDelete () {
      this.btnLoader = true
      const formData = { userId: this.userId, id: this.deleteIndex }
      let isPromise = new Promise((resolve, reject) => {
        this.$store.dispatch('CodeYearModule/deleteCodeYearItem', { resolve, reject, formData })
      })
      isPromise
        .then((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
        .catch((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
    }
  }
}
</script>
